import axios from 'axios';
import { createHttpClient } from '@nw4/api';
import { API_CONFIG } from '@/config/apiConfig';

export const apiClient = createHttpClient(axios, {
  baseURL: API_CONFIG.baseUrl,
});

export default apiClient;
